<svg
  class="eneqto-logo__svg"
  [class.is-expanded]="expanded()"
  [attr.viewBox]="viewBox()"
  fill="none"
  role="img"
  aria-label="ENEQTO"
  xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="eneqto-a" x1="379.1" y1="183.57" x2="395.96" y2="188.62" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#dae3f1" />
      <stop offset="100%" stop-color="#c6dfe6" />
    </linearGradient>
    <linearGradient id="eneqto-b" x1="395.96" y1="188.62" x2="413.49" y2="189.91" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#c6dfe6" />
      <stop offset="100%" stop-color="#b2dbdb" />
    </linearGradient>
    <linearGradient id="eneqto-c" x1="413.49" y1="189.91" x2="430.79" y2="186.84" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#b2dbdb" />
      <stop offset="100%" stop-color="#9dd6cf" />
    </linearGradient>
    <linearGradient id="eneqto-d" x1="430.79" y1="186.84" x2="446.65" y2="179.34" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#9dd6cf" />
      <stop offset="100%" stop-color="#89d2c4" />
    </linearGradient>
    <linearGradient id="eneqto-e" x1="446.65" y1="179.34" x2="460.06" y2="167.99" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#89d2c4" />
      <stop offset="100%" stop-color="#75ceb9" />
    </linearGradient>
    <linearGradient id="eneqto-f" x1="460.06" y1="167.99" x2="470.29" y2="153.7" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#75ceb9" />
      <stop offset="100%" stop-color="#61caae" />
    </linearGradient>
    <linearGradient id="eneqto-g" x1="470.29" y1="153.7" x2="476.82" y2="137.36" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#61caae" />
      <stop offset="100%" stop-color="#4dc6a3" />
    </linearGradient>
    <linearGradient id="eneqto-h" x1="476.82" y1="137.36" x2="479.76" y2="120.03" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#4dc6a3" />
      <stop offset="100%" stop-color="#38c197" />
    </linearGradient>
    <linearGradient id="eneqto-i" x1="479.76" y1="120.03" x2="478.93" y2="102.47" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#38c197" />
      <stop offset="100%" stop-color="#24bd8c" />
    </linearGradient>
    <linearGradient id="eneqto-j" x1="478.93" y1="102.47" x2="474.42" y2="85.48" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#24bd8c" />
      <stop offset="100%" stop-color="#10b981" />
    </linearGradient>
    <linearGradient id="eneqto-k" x1="423.47" y1="41.3" x2="405.11" y2="40.21" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#10b981" />
      <stop offset="100%" stop-color="#21bc8a" />
    </linearGradient>
    <linearGradient id="eneqto-l" x1="405.11" y1="40.21" x2="387.02" y2="43.66" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#21bc8a" />
      <stop offset="100%" stop-color="#32c094" />
    </linearGradient>
    <linearGradient id="eneqto-m" x1="387.02" y1="43.66" x2="369.97" y2="50.67" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#32c094" />
      <stop offset="100%" stop-color="#42c49d" />
    </linearGradient>
    <linearGradient id="eneqto-n" x1="369.97" y1="50.67" x2="354.32" y2="60.43" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#42c49d" />
      <stop offset="100%" stop-color="#53c7a6" />
    </linearGradient>
    <linearGradient id="eneqto-o" x1="354.32" y1="60.43" x2="339.96" y2="72.01" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#53c7a6" />
      <stop offset="100%" stop-color="#64cbb0" />
    </linearGradient>
    <linearGradient id="eneqto-p" x1="339.96" y1="72.01" x2="326.71" y2="84.86" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#64cbb0" />
      <stop offset="100%" stop-color="#75ceb9" />
    </linearGradient>
    <linearGradient id="eneqto-q" x1="326.71" y1="84.86" x2="314.24" y2="98.47" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#75ceb9" />
      <stop offset="100%" stop-color="#86d1c2" />
    </linearGradient>
    <linearGradient id="eneqto-r" x1="314.24" y1="98.47" x2="302.15" y2="112.42" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#86d1c2" />
      <stop offset="100%" stop-color="#97d5cc" />
    </linearGradient>
    <linearGradient id="eneqto-s" x1="302.15" y1="112.42" x2="290.18" y2="126.48" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#97d5cc" />
      <stop offset="100%" stop-color="#a8d8d5" />
    </linearGradient>
    <linearGradient id="eneqto-t" x1="290.18" y1="126.48" x2="277.93" y2="140.29" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#a8d8d5" />
      <stop offset="100%" stop-color="#b8dcde" />
    </linearGradient>
    <linearGradient id="eneqto-u" x1="277.93" y1="140.29" x2="265" y2="153.46" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#b8dcde" />
      <stop offset="100%" stop-color="#c9e0e8" />
    </linearGradient>
    <linearGradient id="eneqto-v" x1="265" y1="153.46" x2="251.09" y2="165.6" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#c9e0e8" />
      <stop offset="100%" stop-color="#dae3f1" />
    </linearGradient>
  </defs>
  <g class="mark" stroke-width="25" stroke-linejoin="round">
    <path
      pathLength="1"
      d="m333.77 152.32 3.43 3.18 4.1 3.7 4.3 3.7 4.3 3.5 4.6 3.3 4.6 3.3 4.8 3 5 2.8 5.2 2.6 5 2.17"
      stroke="#dae3f1" />
    <path
      pathLength="1"
      d="m379.1 183.57.3.13 5.5 2 5.6 1.7 5.61 1.26"
      stroke="url(#eneqto-a)"
      stroke-linecap="round" />
    <path pathLength="1" d="m395.81 188.59.49.11 5.9.9 6 .4 5.44-.09" stroke="url(#eneqto-b)" stroke-linecap="round" />
    <path
      pathLength="1"
      d="m413.34 189.92 1.06-.02 6.2-.6 6.2-1.3 4.13-1.2"
      stroke="url(#eneqto-c)"
      stroke-linecap="round" />
    <path
      pathLength="1"
      d="m430.64 186.88 2.36-.68 6.1-2.5 6-3.3 1.68-1.15"
      stroke="url(#eneqto-d)"
      stroke-linecap="round" />
    <path
      pathLength="1"
      d="m446.53 179.42 4.27-2.92 5.5-4.6 3.87-4.02"
      stroke="url(#eneqto-e)"
      stroke-linecap="round" />
    <path
      pathLength="1"
      d="m459.96 168.1 1.44-1.5 4.6-5.9 4.1-6.6.26-.54"
      stroke="url(#eneqto-f)"
      stroke-linecap="round" />
    <path pathLength="1" d="m470.23 153.83 3.27-6.83 2.8-7.6.55-2.18" stroke="url(#eneqto-g)" stroke-linecap="round" />
    <path pathLength="1" d="m476.78 137.51 1.52-6.01 1.3-8.2.16-3.42" stroke="url(#eneqto-h)" stroke-linecap="round" />
    <path pathLength="1" d="M479.75 120.18 480 115l-.4-8.3-.69-4.38" stroke="url(#eneqto-i)" stroke-linecap="round" />
    <path pathLength="1" d="m478.95 102.62-.65-4.12-2-7.9-1.88-5.12" stroke="url(#eneqto-j)" stroke-linecap="round" />
    <path
      pathLength="1"
      d="M474.47 85.63 473.5 83l-3.4-7.1-4.1-6.6-4.6-5.9-5.1-5.3-5.5-4.6-5.7-3.9-6-3.3-6.1-2.5-6.2-1.8-3.48-.73"
      stroke="#10b981"
      stroke-linecap="round" />
    <path
      pathLength="1"
      d="m423.47 41.3-2.87-.6-6.2-.6-6.2-.1-3.24.22"
      stroke="url(#eneqto-k)"
      stroke-linecap="round" />
    <path
      pathLength="1"
      d="m405.26 40.2-3.06.2-5.9.9-5.8 1.3-3.63 1.1"
      stroke="url(#eneqto-l)"
      stroke-linecap="round" />
    <path
      pathLength="1"
      d="m387.16 43.61-2.26.69-5.5 2-5.3 2.3-4.27 2.13"
      stroke="url(#eneqto-m)"
      stroke-linecap="round" />
    <path
      pathLength="1"
      d="m370.1 50.6-1.2.6-5 2.8-4.8 3-4.6 3.3-.3.21"
      stroke="url(#eneqto-n)"
      stroke-linecap="round" />
    <path
      pathLength="1"
      d="m354.45 60.34-4.55 3.26-4.3 3.5-4.3 3.7-1.45 1.31"
      stroke="url(#eneqto-o)"
      stroke-linecap="round" />
    <path
      pathLength="1"
      d="m340.07 71.91-2.87 2.59-4.1 3.8-3.9 4-2.6 2.66"
      stroke="url(#eneqto-p)"
      stroke-linecap="round" />
    <path
      pathLength="1"
      d="m326.82 84.75-1.42 1.45-3.8 4-3.7 4.1-3.6 4.1-.16.18"
      stroke="url(#eneqto-q)"
      stroke-linecap="round" />
    <path
      pathLength="1"
      d="m314.34 98.35-.04.05-3.6 4.1-3.6 4.2-3.6 4.1-1.45 1.74"
      stroke="url(#eneqto-r)"
      stroke-linecap="round" />
    <path
      pathLength="1"
      d="M302.25 112.3 300 115l-3.5 4.2-3.6 4.1-2.82 3.29"
      stroke="url(#eneqto-s)"
      stroke-linecap="round" />
    <path
      pathLength="1"
      d="m290.28 126.36-.98 1.14-3.6 4.1-3.6 4.1-3.7 4.1-.57.6"
      stroke="url(#eneqto-t)"
      stroke-linecap="round" />
    <path
      pathLength="1"
      d="m278.04 140.18-3.44 3.62-3.8 3.9-3.9 4-2.01 1.87"
      stroke="url(#eneqto-u)"
      stroke-linecap="round" />
    <path
      pathLength="1"
      d="m265.11 153.36-2.31 2.14-4.1 3.7-4.3 3.7-3.31 2.7"
      stroke="url(#eneqto-v)"
      stroke-linecap="round" />
    <path
      pathLength="1"
      d="m251.2 165.5-1.1.9-4.6 3.3-4.6 3.3-4.8 3-5 2.8-5.2 2.6-5.3 2.3-5.5 2-5.6 1.7-5.8 1.3-5.9.9-6 .4-6.2-.1-6.2-.6-6.2-1.3-6.2-1.8-6.1-2.5-6-3.3-5.7-3.9-5.5-4.6-5.1-5.3-4.6-5.9-4.1-6.6-3.4-7.1-2.8-7.6-2-7.9-1.3-8.2-.4-8.3.4-8.3 1.3-8.2 2-7.9 2.8-7.6 3.4-7.1 4.1-6.6 4.6-5.9 5.1-5.3 5.5-4.6 5.7-3.9 6-3.3 6.1-2.5 6.2-1.8 6.2-1.3 6.2-.6 6.2-.1 6 .4 5.9.9 5.8 1.3 5.6 1.7 5.5 2 5.3 2.3 5.2 2.6 5 2.8 4.8 3 4.6 3.3 4.6 3.3 4.3 3.5 4.3 3.7 4.1 3.7 3.43 3.18"
      stroke="#dae3f1" />
  </g>
  <g class="wordmark">
    <text
      x="700"
      y="140"
      text-anchor="middle"
      fill="#dae3f1"
      font-family="Manrope, Inter, Arial, sans-serif"
      font-size="58"
      font-weight="600"
      letter-spacing="8">
      ENEQTO
    </text>
  </g>
</svg>
